import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type LoadingState = {
  [key: string]: boolean;
};

const initialState: LoadingState = {};

const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    clearThunkStatus: (state, action: PayloadAction<string>) => {
      const prefix = action.payload;
      Object.keys(state).forEach((key) => {
        if (key.startsWith(`${prefix}/`)) {
          delete state[key];
        }
      });
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        (action): action is { type: string } =>
          action.type.endsWith("/pending"),
        (state, action) => {
          state[action.type] = true;
        }
      )
      .addMatcher(
        (action): action is { type: string } =>
          action.type.endsWith("/fulfilled") ||
          action.type.endsWith("/rejected"),
        (state, action) => {
          const pendingType = action.type.replace(
            /\/(fulfilled|rejected)$/,
            "/pending"
          );
          state[pendingType] = false;
          state[action.type] = true;
        }
      );
  },
});

export const { clearThunkStatus } = loadingSlice.actions;
export default loadingSlice.reducer;
